var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.108,
    height: 70.109,
    viewBox: "0 0 70.108 70.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verify",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M29.988,48.975A18.988,18.988,0,1,1,48.975,29.988,19.01,19.01,0,0,1,29.988,48.975Zm0-35.054A16.067,16.067,0,1,0,46.054,29.988,16.086,16.086,0,0,0,29.988,13.921Z",
    transform: "translate(21.132 21.133)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M21.3,29.606a1.476,1.476,0,0,1-1.034-.426l-5.842-5.842a1.46,1.46,0,1,1,2.065-2.065L21.23,26.01l9.2-10.51a1.461,1.461,0,0,1,2.2,1.922L22.4,29.107a1.471,1.471,0,0,1-1.052.5H21.3Z",
    transform: "translate(26.896 28.817)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M27.751,55.581H7.3a7.311,7.311,0,0,1-7.3-7.3V10.3A7.311,7.311,0,0,1,7.3,3h5.842a1.461,1.461,0,0,1,0,2.921H7.3A4.387,4.387,0,0,0,2.921,10.3V48.278A4.387,4.387,0,0,0,7.3,52.66H27.751a1.461,1.461,0,0,1,0,2.921Z",
    transform: "translate(-0.001 5.764)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M25.145,20.527a1.461,1.461,0,0,1-1.461-1.461V10.3A4.387,4.387,0,0,0,19.3,5.921H13.461a1.461,1.461,0,1,1,0-2.921H19.3a7.311,7.311,0,0,1,7.3,7.3v8.764A1.461,1.461,0,0,1,25.145,20.527Z",
    transform: "translate(23.054 5.764)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M25.909,17.527H8.382A4.387,4.387,0,0,1,4,13.145V7.3A1.461,1.461,0,0,1,5.461,5.842H9.988a7.3,7.3,0,0,1,14.314,0H28.83A1.461,1.461,0,0,1,30.291,7.3v5.842A4.387,4.387,0,0,1,25.909,17.527ZM6.921,8.764v4.382a1.463,1.463,0,0,0,1.461,1.461H25.909a1.463,1.463,0,0,0,1.461-1.461V8.764H22.988A1.461,1.461,0,0,1,21.527,7.3a4.382,4.382,0,1,0-8.764,0A1.461,1.461,0,0,1,11.3,8.764Z",
    transform: "translate(7.684 0)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M33.672,10.921H4.461A1.461,1.461,0,0,1,4.461,8H33.672a1.461,1.461,0,0,1,0,2.921Z",
    transform: "translate(5.763 15.37)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M24.909,13.921H4.461a1.461,1.461,0,1,1,0-2.921H24.909a1.461,1.461,0,1,1,0,2.921Z",
    transform: "translate(5.763 21.133)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M19.067,16.921H4.461a1.461,1.461,0,1,1,0-2.921H19.067a1.461,1.461,0,1,1,0,2.921Z",
    transform: "translate(5.763 26.897)",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/Verify.3ce2e5eaaef00327c998a043e96d1970.svg";
export { ForwardRef as ReactComponent };